import $ from 'jquery';
import 'owl.carousel';
import "jquery-mask-plugin";
import axios from "axios";
const slick = require('slick-carousel');

$(document).ready(function () {
    $(".hero").owlCarousel({
        items: 1,
        dots: true,
    });

    $('[type="tel"]').mask("(99) 99999-9999");
    $('.cnpj').mask("99.999.999/9999-99");

    $(".ultimas-owl").owlCarousel({
        items: 3,
        margin: 73,
        dots: true,
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 3,
            }
        }
    });
    $('.slick').each(function () {
        $(this).slick({
            dots: false,
            arrows: true,
            margin: 24,
            infinite: true,
            speed: 300,
            rows: 3,
            slidesToShow: 5,
            slidesToScroll: 5,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        rows: 3,
                        slidesToShow: 5,
                        slidesToScroll: 5,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        rows: 1,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
            ],
            nextArrow: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"33.252\" height=\"56.621\" viewBox=\"0 0 33.252 56.621\">\n" +
                "  <path id=\"seta_nav_dir\" d=\"M85.145,26.089,59.963.906a3.1,3.1,0,0,0-4.378,0L53.729,2.764a3.083,3.083,0,0,0,0,4.378L74.887,28.3,53.706,49.48a3.1,3.1,0,0,0,0,4.378l1.857,1.857a3.1,3.1,0,0,0,4.378,0l25.2-25.2a3.114,3.114,0,0,0,.906-2.189,2.987,2.987,0,0,0-.906-2.189Z\" transform=\"translate(-52.8)\" fill=\"#d2d2d2\"/>\n" +
                "</svg>",
            prevArrow: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"33.252\" height=\"56.621\" viewBox=\"0 0 33.252 56.621\">\n" +
                "  <path id=\"seta_nav_esq\" d=\"M53.706,26.133a2.987,2.987,0,0,0-.906,2.189,3.076,3.076,0,0,0,.906,2.189l25.2,25.2a3.1,3.1,0,0,0,4.378,0l1.857-1.857a3.1,3.1,0,0,0,0-4.378L63.965,28.3,85.123,7.141a3.083,3.083,0,0,0,0-4.378L83.266.906a3.1,3.1,0,0,0-4.378,0L53.706,26.089Z\" transform=\"translate(-52.8)\" fill=\"#d2d2d2\"/>\n" +
                "</svg>",

        });
    })


    $(".more_posts").click(function () {
        axios.get(theme_vars.template_directory + "/more_posts/", {
            params: {
                category_name: $(".more_posts").attr("data-category-name"),
                paged: $(".more_posts").attr("data-paged"),
                search: $(".more_posts").attr("data-search"),
            }
        }).then(z => {
            $(".posts-append").append(z.data);
            if(z.headers.get("x-wp-next-paged")) {
                $(".more_posts").attr("data-paged", z.headers.get("x-wp-next-paged"));
            } else {
                $(".more_posts").hide();
            }
        }).catch(() => {
            alert("Ocorreu um erro... por favor, tente novamente mais tarde")
        });

    })

    $(".menu-mobile").click(function () {
        $("header").toggleClass("act");
    });
});